import { signal } from '@angular/core';
import { ExpertUserInfo } from '@core/models/expert-user.model';
import { Jwt } from '@core/models/jwt.model';

export const jwtCredentials = signal<Jwt | null>(null);
export const refreshingToken = signal<boolean>(false);
export const expertInfo = signal<ExpertUserInfo | null>(null);
